import axios from '@customAxios';
var API_BASE_URL = '/api/facebook';
var FacebookAxios = axios.create({
    baseURL: API_BASE_URL,
});
var sendEvent = function (requestBody) {
    return FacebookAxios.post('/send_event', requestBody);
};
export { sendEvent };
